// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewRoom_wrapper__2wpIj","title_quiz":"PreviewRoom_title_quiz__sktDh","btn_start":"PreviewRoom_btn_start__3dxrj","cards_wrapper":"PreviewRoom_cards_wrapper__FJrxh"};